const sentryConfigs = {
	DSN: 'https://633846f1d50948208b7f95e61686b12c@sentry.io/1475774',
	ENV: 'ttc-sentry',
}

const getSentryVersion = () => {
	const data = require('../../sentryVersion.json')
	return data.id
}

export { sentryConfigs, getSentryVersion }
